import { render, staticRenderFns } from "./SalesInvoiceLines.vue?vue&type=template&id=63264d7c"
import script from "./SalesInvoiceLines.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesInvoiceLines.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports